import createEnum from 'scripts/lib/create_enum';

const MessageContentType = createEnum('TEXT', 'IMAGE', 'FILE', 'LOCATION');

export default MessageContentType;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/message_content_type.js